import clsx from 'clsx'

import ModalImage from 'react-modal-image'
import { useStyles } from './style'

const ModalImageCors = ({ imageUrl, isDeleted, data }) => {
  const classes = useStyles()

  return (
    <ModalImage
      className={[
        clsx(classes.messageMedia, {
          [classes.messageMediaDeleted]: isDeleted,
          [classes.messageMediaSticker]:
            data && 'stickerMessage' in data.message
        })
      ]}
      smallSrcSet={imageUrl}
      medium={imageUrl}
      large={imageUrl}
      showRotate={true}
      imageBackgroundColor="unset"
      alt="image"
    />
  )
}

export default ModalImageCors
